module.exports = __webpack_public_path__ + "static/media/money-svgrepo-com.8093fd4d.svg";